module.exports = __webpack_public_path__ + "media/media.05fd2067.mp4";